// Shared helpers for handling the HTML markup Wealthbox stores in its
// long-text fields (notes `content`, tasks `description`, events `description`).
//
// Wealthbox auto-wraps any plaintext sent over the API in <div> tags and
// preserves any rich markup (links, lists, line breaks) added through its
// native UI. We sanitize-and-render that HTML when *viewing* (see the atom
// `Markup`), and strip to plaintext when populating textarea editors so users
// edit prose, not raw markup. Round-tripping plaintext through Wealthbox is
// lossless for prose; rich markup added in Wealthbox itself is intentionally
// flattened when edited here (acceptable v1 tradeoff - if product wants WYSIWYG,
// swap the textarea for a rich-text editor in a follow-up ticket).

export function htmlToPlainText (html) {
  if (!html || typeof html !== 'string') return ''
  const withLineBreaks = html
    .replace(/<\s*br\s*\/?>/gi, '\n')
    .replace(/<\/\s*(div|p|li|h[1-6])\s*>/gi, '\n')
  if (typeof document === 'undefined') {
    return withLineBreaks.replace(/<[^>]+>/g, '').replace(/\n{3,}/g, '\n\n').trim()
  }
  const template = document.createElement('template')
  template.innerHTML = withLineBreaks
  return (template.content.textContent || '').replace(/\n{3,}/g, '\n\n').trim()
}
